
export function __translate(str, variables) {
    if (!variables) return str;

    var count = 0;
    if (variables == typeof Array) count = variables.length;
    else count = 1;

    // not yet working for arrays !!
    for (let i = 0; i < count; i++) {
        var substring1 = str.split("%{")[0];
        var substring2 = str.split("}")[1];
        var return_string = substring1 + variables + substring2;
    }

    return return_string;
}

export function __parseDate(input, format) {
    try {
        format = format || 'YYYY-MM-DD hh:mm'; // default format
        var parts = input.match(/(\d+)/g),
            i = 0, fmt = {};
        // extract date-part indexes from the format
        format.replace(/(YYYY|DD|MM|hh|mm)/g, function (part) { fmt[part] = i++ });
        return parts[fmt['YYYY']]+"-"+(parts[fmt['MM']].length == 1 ? "0" + parts[fmt['MM']] : parts[fmt['MM']] )+"-"+(parts[fmt['DD']].length == 1 ? "0" + parts[fmt['DD']] : parts[fmt['DD']])+"T"+(parts[3].length == 1 ? "0"+parts[3] : parts[3]) +":"+parts[4]+":00.000Z";
    } catch (e) {
        return new Date(0);
    }
}

export function cleanISODateToHumanReadable(date, format) {
    date = date.split("T")[0]+" "+date.split("T")[1];
    date = date.split(".000Z")[0];
    if (format.split('/').length > 1) date = date.replaceAll('-', '/');
    if (format.split('.').length > 1) date = date.replaceAll('-', '.');
    return date
}